/**
 * Envelope extraction utilities for FM (Teltonika) and AIS (AIS140) devices
 */

/**
 * Extract live Modbus data object from getDeviceStatus response
 * @param {object} statusJson - API response or vstatData or vstatObj
 * @returns {object|null} rs485modbus object or null
 */
export function extractLiveModbus(statusJson) {
  const vstatObj = statusJson?.vstatData?.vstatObj ?? statusJson?.vstatObj ?? statusJson;
  return vstatObj?.fm?.ioElements?.rs485modbus ?? vstatObj?.ais?.rs485modbus ?? null;
}

/**
 * Extract live location { latitude, longitude, timestamp } from getDeviceStatus response
 * @param {object} statusJson - API response or vstatData or vstatObj
 * @returns {object|null} location object or null
 */
export function extractLiveLocation(statusJson) {
  const vstatObj = statusJson?.vstatData?.vstatObj ?? statusJson?.vstatObj ?? statusJson;
  if (!vstatObj) return null;

  if (vstatObj.fm && (vstatObj.fm.latitude !== undefined || vstatObj.fm.longitude !== undefined || vstatObj.fm.deviceTimeStamp !== undefined)) {
    return {
      latitude: vstatObj.fm.latitude,
      longitude: vstatObj.fm.longitude,
      timestamp: vstatObj.fm.deviceTimeStamp || vstatObj.localTimeStamp || null,
    };
  }

  if (vstatObj.ais && (vstatObj.ais.lat !== undefined || vstatObj.ais.lng !== undefined || vstatObj.ais.deviceTimeStamp !== undefined)) {
    return {
      latitude: vstatObj.ais.lat,
      longitude: vstatObj.ais.lng,
      timestamp: vstatObj.ais.deviceTimeStamp || vstatObj.localTimeStamp || null,
    };
  }

  return null;
}

/**
 * Extract Modbus data from a historic location record
 * Supports FM (record.params.rs485modbus / record.params.ziptrax) and AIS (record.rs485modbus)
 * @param {object} record - Location interval record
 * @returns {object|null} rs485modbus object or null
 */
export function extractRecordModbus(record) {
  return record?.params?.ziptrax ?? record?.params?.rs485modbus ?? record?.rs485modbus ?? null;
}

/**
 * Appends analysis=true query parameter to a URL if not already present
 * @param {string} url - Fetch URL
 * @returns {string} URL with analysis=true
 */
export function withAnalysisFlag(url) {
  if (!url) return url;
  if (/[?&]analysis=true(&|$)/.test(url)) return url;
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}analysis=true`;
}
